// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"30ff255d","159":"f6cc37b7","188":"f65893cf","221":"198c3da5","515":"09f720d2","767":"b184312b","872":"1b1b4f93"}[chunkId] + ".chunk.js";
};